const normalizeLocaleValue = (localeValue) => {
    if (!localeValue || typeof localeValue !== 'string') return ''
    return localeValue.replace('_', '-')
}

const getLocaleFromPathname = (pathname = '') => {
    const match = pathname.match(/^\/([a-z]{2}-[a-z]{2})(\/|$)/i)
    return match?.[1] || ''
}

const inferLanguageFromText = (title = '', text = '') => {
    const sample = `${title} ${text}`.toLowerCase()
    if (!sample.trim()) return ''

    const normalizedSample = sample
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[’]/g, "'")

    const frenchTokens = normalizedSample.match(/\b[\p{L}']+\b/gu) || []
    const englishTokens = normalizedSample.match(/\b[\p{L}]+\b/gu) || []
    const frenchWords = new Set([
        "c'est",
        'tres',
        'meilleur',
        'produit',
        'recommande',
        'vivement',
        'bonjour',
        'merci',
        'le',
        'la',
        'les',
        'des',
        'une',
        'un',
        'est',
        'dans',
        'avec',
        'pour',
        'qui',
        'soit'
    ])
    const englishWords = new Set([
        'the',
        'this',
        'that',
        'is',
        'are',
        'with',
        'for',
        'very',
        'best',
        'product',
        'recommend'
    ])

    const frenchScore = frenchTokens.reduce((acc, token) => acc + (frenchWords.has(token) ? 1 : 0), 0)
    const englishScore = englishTokens.reduce((acc, token) => acc + (englishWords.has(token) ? 1 : 0), 0)

    if (frenchScore >= 2 && frenchScore > englishScore) return 'fr'
    if (englishScore >= 1 && englishScore > frenchScore) return 'en'
    return ''
}

export {normalizeLocaleValue, getLocaleFromPathname, inferLanguageFromText}
